export default {
  moduleProcesses: [],
  moduleProcess: undefined,
};
